<template>
  <q-card v-bind="$attrs">
    <slot></slot>
  </q-card>
</template>
